import { createFileRoute, Navigate } from '@tanstack/react-router'

/**
 * Billing moved under Startup settings. This route stays because Stripe's
 * checkout return URLs point at it (see wallet.handler.ts), and any link a
 * founder saved still works — it forwards to the tab.
 */
export const Route = createFileRoute('/app/startup/$id/billing')({
  component: BillingRedirect,
})

function BillingRedirect() {
  const { id } = Route.useParams()
  return <Navigate to="/app/startup/$id/settings/billing" params={{ id }} replace />
}
